/**
 * Strato di gestione delle chiamate http
 * @module api
 */
import Vue from 'vue'
import { API_URL } from '@/utils';

export default {
    /**
     * @function get
     * @param {string} - url
     * @param {object} - request
     */
    get(url, request) {
        return Vue.http.get(API_URL + url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    /**
     * @function post
     * @param {string} - url
     * @param {object} - request
     * @param {object} - options
     */
    post(url, request, options) {
        return Vue.http.post(API_URL + url, request, options)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    /**
     * @function put
     * @param {string} - url
     * @param {object} - request
     */
    put(url, request) {
        return Vue.http.put(API_URL + url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    /**
     * @function delete
     * @param {string} - url
     * @param {object} - request
     */
    delete(url, request) {
        return Vue.http.delete(API_URL + url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    }
}


// WEBPACK FOOTER //
// ./src/api.js